import React from 'react';

import {
  COMPONENT_SIZE_DYNAMIC,
  // ComponentSizes
  COMPONENT_SIZE_MEDIUM,
  COMPONENT_SIZE_SMALL,
  // Types
  Color,
  ComponentSize,
  FontSize,
  FontWeight,
} from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import Text from '../text/text';

import './player-formation-place-icon.scss';

export const componentSizeListCustom: ComponentSize[] = [
  COMPONENT_SIZE_SMALL,
  COMPONENT_SIZE_MEDIUM,
  COMPONENT_SIZE_DYNAMIC,
];

export interface IPlayerFormationPlaceIconLabel extends IComponent {
  fontSizeLabel?: FontSize;
  fontWeightLabel?: FontWeight;
  colorLabel?: Color;
}

export interface IPlayerFormationPlaceIconName extends IComponent {
  fontSizeName?: FontSize;
  fontWeightName?: FontWeight;
  colorName?: Color;
}
export interface IPlayerFormationPlaceIcon extends IPlayerFormationPlaceIconLabel, IPlayerFormationPlaceIconName {
  readonly isCircled?: boolean;
  readonly name: string;
  readonly label: string;
  readonly altColor?: boolean;
}

const classNames = (size: ComponentSize, isCircled: boolean, altColor: boolean) =>
  makeClassNames({
    PlayerFormationPlaceIcon: ['player-formation-place-icon', size && `player-formation-place-icon--${size}`],
    PlayerFormationPlaceIconShape: [
      'player-formation-place-icon-shape',
      isCircled && `player-formation-place-icon-shape--circled`,
      !altColor && `player-formation-place-icon-shape--alternative-color`,
    ],
    PlayerFormationPlaceIconNumber: 'player-formation-place-icon-number',
    PlayerFormationPlaceIconName: 'player-formation-place-icon-name',
  });

const PlayerFormationPlaceIcon = ({
  /* istanbul ignore next: default value on mandatory field */ isCircled = true,
  name,
  /* istanbul ignore next: default value on mandatory field */ colorName = 'light',
  /* istanbul ignore next: default value on mandatory field */ fontWeightName = '500',
  label,
  /* istanbul ignore next: default value on mandatory field */ colorLabel = 'blue',
  /* istanbul ignore next: default value on mandatory field */ fontWeightLabel = '500',
  /* istanbul ignore next: default value on mandatory field */ size = COMPONENT_SIZE_SMALL,
  /* istanbul ignore next: default value on mandatory field */ altColor = false,
}: IPlayerFormationPlaceIcon) => {
  const cn = classNames(size, isCircled, altColor);
  const fontsize = size === 'small' ? '12' : '12--14';
  return (
    <div className={cn.PlayerFormationPlaceIcon}>
      <div className={cn.PlayerFormationPlaceIconShape}>
        {label && (
          <Text
            className={cn.PlayerFormationPlaceIconNumber}
            tag="span"
            fontSize={fontsize}
            fontWeight={fontWeightLabel}
            color={altColor ? colorLabel : 'light'}
          >
            {label}
          </Text>
        )}
      </div>
      {name && (
        <Text
          className={cn.PlayerFormationPlaceIconName}
          tag="p"
          fontSize={fontsize}
          fontWeight={fontWeightName}
          color={colorName}
        >
          {name}
        </Text>
      )}
    </div>
  );
};

export default PlayerFormationPlaceIcon;
